import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const businessServices = [
  {
    id: 'carbon-report',
    icon: 'ri-government-line',
    color: 'from-emerald-500/20 to-teal-500/20',
    borderColor: 'border-emerald-500/30',
    iconColor: 'text-emerald-400',
    tag: '工信部官方体系',
    title: '工信部碳排放申报服务',
    subtitle: '全流程合规 · 12项核心功能 · 零报错直连',
    desc: '适配国内工信部碳排放官方申报体系，涵盖数字化能碳管理中心建设指南全部12项核心功能，提供从数据采集到申报完成的全流程合规服务，助力工业企业和园区高效通过建设评估。',
    features: [
      '能耗查询与多维度数据追溯',
      '能源消费量和强度自动计算',
      'AI能源消费分析与用能策略推荐',
      '能效对标与行业基准分析',
      '能流可视化分析',
      '能效平衡与优化',
      '用能与碳排放预算管理',
      '碳排放核算（范围一、二）',
      '产品碳足迹核算（ISO 14067）',
      '供应链碳管理（范围三）',
      '碳核查全流程数据支撑',
      '碳资产管理与交易辅助',
    ],
    process: [
      { step: '01', title: '咨询对接', desc: '专属顾问评估企业现状，制定申报方案' },
      { step: '02', title: '数据采集', desc: 'IoT传感器自动采集，AI标准化处理' },
      { step: '03', title: '系统填报', desc: 'AI核算报告，一键直连官方平台' },
      { step: '04', title: '核查跟进', desc: '第三方核查配合，数据完整归档' },
      { step: '05', title: '申报完成', desc: '全程合规存证，履约预警提醒' },
    ],
    stats: [{ v: '12项', l: '功能全覆盖' }, { v: '500+', l: '工业客户' }, { v: '99.5%', l: '数据准确率' }, { v: '<5分钟', l: '报告生成' }],
    href: '/business/carbon-report',
    image: 'https://readdy.ai/api/search-image?query=industrial%20factory%20carbon%20emission%20monitoring%20digital%20dashboard%20compliance%20reporting%20system%20professional%20green%20interface%20dark%20themed%20modern%20enterprise%20software%20China%20manufacturing%20energy%20management&width=600&height=380&seq=biz1&orientation=landscape',
  },
  {
    id: 'industrial-ai',
    icon: 'ri-robot-2-line',
    color: 'from-cyan-500/20 to-blue-500/20',
    borderColor: 'border-cyan-500/30',
    iconColor: 'text-cyan-400',
    tag: 'AI工厂落地',
    title: '工业AI智能化解决方案',
    subtitle: '深度落地 · 定制开发 · 降本增效',
    desc: 'AI技术深度落地工厂实景，赋能工业生产全流程数字化、智能化升级。从生产工艺优化到设备预测运维，从AI视觉质检到数字孪生工厂，提供完整的工业AI落地解决方案。',
    features: [
      '生产工艺AI智能优化',
      '设备AI预测性运维（故障提前预警）',
      'AI视觉质检（自动缺陷识别）',
      '能耗智能管控与节能优化',
      '数字孪生工厂建模',
      '安全生产AI视频监控',
      '定制化AI模型开发与部署',
      '轻量化边缘计算部署方案',
      '工业大数据平台建设',
      '智能排产与生产计划优化',
    ],
    process: [
      { step: '01', title: '工厂诊断', desc: '全面评估工厂现状，识别AI应用场景' },
      { step: '02', title: '方案设计', desc: '定制AI技术方案，确定落地优先级' },
      { step: '03', title: '系统开发', desc: 'AI模型训练，工业软件定制开发' },
      { step: '04', title: '部署集成', desc: '轻量化部署，与现有系统无缝集成' },
      { step: '05', title: '运维升级', desc: '持续优化模型，提供长期运维支持' },
    ],
    stats: [{ v: '60%', l: '故障率降低' }, { v: '35%', l: '综合节能率' }, { v: '99%', l: 'AI质检准确率' }, { v: '7×24', l: '智能监控' }],
    href: '/business/industrial-ai',
    image: 'https://readdy.ai/api/search-image?query=smart%20factory%20interior%20with%20robotic%20arms%20AI%20monitoring%20screens%20industrial%20automation%20IoT%20sensors%20digital%20twin%20visualization%20professional%20manufacturing%20technology%20bright%20modern&width=600&height=380&seq=biz2&orientation=landscape',
  },
  {
    id: 'ccer-cbam',
    icon: 'ri-global-line',
    color: 'from-violet-500/20 to-purple-500/20',
    borderColor: 'border-violet-500/30',
    iconColor: 'text-violet-400',
    tag: '国际合规认证',
    title: 'CCER/CBAM合规填报与数据上报',
    subtitle: '国家平台直连 · 欧盟合规 · 全程代办',
    desc: '提供CCER全国温室气体自愿减排项目全流程服务，支持直连国家注册登记系统完成数据上报；同步提供欧盟碳边境调节机制（CBAM）跨境碳合规填报服务，助力外贸企业合规出口。',
    features: [
      'CCER项目备案与方法学匹配',
      '减排量数据归集与核算',
      '全国温室气体自愿减排注册登记系统直连',
      '项目签发与碳资产管理',
      'CBAM欧盟碳边境调节机制填报',
      '产品碳足迹核算（含内嵌碳）',
      'CBAM合规自查与差距分析',
      '出口凭证办理与资料归档',
      '跨境碳合规培训与知识传递',
      '紧跟最新政策，数据格式标准化',
    ],
    process: [
      { step: '01', title: '合规评估', desc: '评估企业CCER/CBAM适用性与准备度' },
      { step: '02', title: '数据归集', desc: '建立数据采集体系，确保数据质量' },
      { step: '03', title: '系统填报', desc: '标准化处理，直连官方平台填报' },
      { step: '04', title: '核查跟进', desc: '配合第三方核查，全程协调跟进' },
      { step: '05', title: '存档履约', desc: '完整归档，持续履约运维支持' },
    ],
    stats: [{ v: '50+', l: 'CCER项目' }, { v: '100%', l: '合规通过率' }, { v: '20+', l: '数据采集类型' }, { v: '15+', l: '核算方法学' }],
    href: '/business/ccer-cbam',
    image: 'https://readdy.ai/api/search-image?query=carbon%20credit%20CCER%20CBAM%20compliance%20digital%20platform%20global%20carbon%20trading%20market%20data%20visualization%20green%20technology%20professional%20dark%20background%20modern%20financial%20tech&width=600&height=380&seq=biz3&orientation=landscape',
  },
  {
    id: 'value-added',
    icon: 'ri-service-line',
    color: 'from-amber-500/20 to-orange-500/20',
    borderColor: 'border-amber-500/30',
    iconColor: 'text-amber-400',
    tag: '增值服务',
    title: '增值配套服务',
    subtitle: '一站式服务 · 专业团队 · 全程保障',
    desc: '围绕工业双碳与AI智能化核心业务，提供全方位增值配套服务，包括碳盘查与核查配合、节能降碳AI优化、ESG报告编制、绿色工厂申报辅导等，构建企业完整的绿色合规服务体系。',
    features: [
      '碳盘查与第三方核查配合',
      '碳资产统一管理与交易策略',
      '节能降碳AI诊断与优化方案',
      'ESG报告编制（GRI、TCFD标准）',
      '绿色工厂认定申报辅导',
      '政策补贴申报代办',
      '企业碳中和路径规划',
      '低碳供应链体系建设',
      '节能技改方案设计',
      '碳合规培训与能力建设',
    ],
    process: [
      { step: '01', title: '需求分析', desc: '深入了解企业增值服务需求' },
      { step: '02', title: '方案定制', desc: '针对性定制服务包与交付方案' },
      { step: '03', title: '专家团队', desc: '碳合规专家+AI技术团队联合交付' },
      { step: '04', title: '成果交付', desc: '高质量报告/方案/证书交付' },
      { step: '05', title: '持续支持', desc: '长期运维支持与政策跟踪服务' },
    ],
    stats: [{ v: '10+', l: '服务类型' }, { v: '95%', l: '客户满意度' }, { v: '30+', l: '行业专家' }, { v: '全程', l: '一站式代办' }],
    href: '/business/value-added',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20consulting%20team%20working%20on%20ESG%20sustainability%20report%20green%20factory%20certification%20carbon%20neutral%20strategy%20meeting%20modern%20office%20bright%20professional%20atmosphere&width=600&height=380&seq=biz4&orientation=landscape',
  },
];

export default function BusinessPage() {
  const navigate = useNavigate();
  const { service } = useParams<{ service?: string }>();
  const [activeService, setActiveService] = useState(0);

  useEffect(() => {
    if (service) {
      const idx = businessServices.findIndex((s) => s.id === service);
      if (idx !== -1) setActiveService(idx);
    }
  }, [service]);

  const current = businessServices[activeService];

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-28 pb-16 md:pt-32 md:pb-20 overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none">
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,217,163,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }} />
          </div>
          <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-firmai-green/8 rounded-full blur-3xl" />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-6">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-briefcase-4-line" /></span>
                工业碳合规 + 工业AI智能化双核心业务
              </span>
              <h1 className="font-display font-bold text-3xl md:text-5xl text-white leading-tight mb-6">
                工业双碳数字化<br />
                <span className="bg-gradient-to-r from-firmai-green to-teal-400 bg-clip-text text-transparent">一站式专业服务</span>
              </h1>
              <p className="text-firmai-text text-base md:text-lg leading-relaxed max-w-3xl mx-auto">
                聚焦工信部碳排放申报、工业AI工厂落地、CCER/CBAM合规填报三大核心业务，服务制造企业、工业园区、外贸出口企业等B端客户，打造工业领域双碳数字化+AI智能化标杆服务商
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 px-7 py-3.5 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  免费预约方案咨询
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </a>
                <a
                  href="/cases"
                  onClick={(e) => { e.preventDefault(); navigate('/cases'); }}
                  className="inline-flex items-center gap-2 px-7 py-3.5 border border-firmai-border text-firmai-text font-medium rounded-md hover:border-firmai-green/40 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  查看标杆案例
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Service Tabs */}
        <section className="py-16 md:py-20 bg-firmai-darker">
          <div className="w-full px-4 md:px-8 lg:px-12">
            {/* Tab Nav */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 p-1.5 bg-firmai-dark/80 border border-firmai-border rounded-xl mb-12 max-w-4xl mx-auto">
              {businessServices.map((svc, idx) => (
                <button
                  key={svc.id}
                  onClick={() => setActiveService(idx)}
                  className={`flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeService === idx ? 'bg-firmai-green text-firmai-dark' : 'text-firmai-text hover:text-white'
                  }`}
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className={svc.icon} />
                  </span>
                  <span className="hidden sm:inline">{svc.title.substring(0, 6)}...</span>
                  <span className="sm:hidden">{svc.tag}</span>
                </button>
              ))}
            </div>

            {/* Content */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
              {/* Left */}
              <div>
                <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-firmai-card border ${current.borderColor} ${current.iconColor} text-xs font-semibold mb-4`}>
                  <span className="w-4 h-4 flex items-center justify-center"><i className={current.icon} /></span>
                  {current.tag}
                </span>
                <h2 className="text-white font-bold text-2xl md:text-3xl mb-3">{current.title}</h2>
                <p className="text-firmai-green text-sm font-medium mb-4">{current.subtitle}</p>
                <p className="text-firmai-text text-sm md:text-base leading-relaxed mb-6">{current.desc}</p>

                {/* Stats */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
                  {current.stats.map((s) => (
                    <div key={s.l} className="bg-firmai-card border border-firmai-border rounded-lg p-3 text-center">
                      <div className="text-firmai-green font-bold text-lg">{s.v}</div>
                      <div className="text-firmai-muted text-xs mt-0.5">{s.l}</div>
                    </div>
                  ))}
                </div>

                {/* Features */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {current.features.map((f) => (
                    <div key={f} className="flex items-center gap-2 text-sm text-firmai-text">
                      <span className="w-4 h-4 flex items-center justify-center text-firmai-green shrink-0">
                        <i className="ri-check-line" />
                      </span>
                      {f}
                    </div>
                  ))}
                </div>

                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  立即咨询
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </a>
              </div>

              {/* Right */}
              <div className="space-y-6">
                <div className="rounded-xl overflow-hidden border border-firmai-border h-56 md:h-72 w-full">
                  <img src={current.image} alt={current.title} className="w-full h-full object-cover object-top" />
                </div>

                {/* Process */}
                <div className="bg-firmai-card border border-firmai-border rounded-xl p-5">
                  <h3 className="text-white font-semibold text-sm mb-4">服务流程</h3>
                  <div className="space-y-3">
                    {current.process.map((p, i) => (
                      <div key={p.step} className="flex items-start gap-3">
                        <div className="w-7 h-7 flex items-center justify-center rounded-full bg-firmai-green/10 border border-firmai-green/30 text-firmai-green text-xs font-bold shrink-0">
                          {i + 1}
                        </div>
                        <div>
                          <div className="text-white text-sm font-medium">{p.title}</div>
                          <div className="text-firmai-muted text-xs mt-0.5">{p.desc}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 md:py-20 bg-firmai-dark">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="font-display font-bold text-2xl md:text-3xl text-white mb-4">
                准备好开启工业双碳智能化之旅？
              </h2>
              <p className="text-firmai-text text-sm md:text-base mb-8 leading-relaxed">
                专属顾问团队为您提供免费现状评估与方案预约，从工信部碳排申报到AI工厂落地，一个电话解决所有问题
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 px-8 py-3.5 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  预约免费咨询
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-line" /></span>
                </a>
                <a
                  href="tel:18916035855"
                  className="inline-flex items-center gap-2 px-8 py-3.5 border border-firmai-border text-firmai-text font-medium rounded-md hover:border-firmai-green/40 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-line" /></span>
                  18916035855
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}